<template>
  <div>
    <md-dialog :md-active="open" class="modal-category">
      <span
        class="material-icons close text-right"
        @click="closeModal"
      >close</span
      >
      <div class="body-modal-category">
        <md-dialog-title>
          {{ isEmpty(item) ? 'EDITAR' : 'NUEVA' }} CATEGORIA
        </md-dialog-title
        >

        <md-dialog-content class="mt-2">
          <span> Ingrese el nombre de la categoria.</span></md-dialog-content
        >

        <md-dialog-content>
          <md-field>
            <div class="md-field md-theme-default md-has-placeholder pt-0">
              <md-input v-model="category.title" placeholder="Nueva categoria"></md-input>
            </div>
          </md-field>
        </md-dialog-content>

        <md-dialog-actions>
          <md-button
            class="md-button md-primary md-theme-default"
            @click="closeModal"
          >CANCELAR
          </md-button
          >
          <base-button
            :loading="isLoading"
            class="md-primary w-100 "
            @click="item ? updateCategory() : createCategory()"
          >{{ item ? 'EDITAR' : 'AGREGAR' }}
          </base-button
          >
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {
  MEDIA_CATEGORY_UPDATE_NAME,
  MEDIA_CREATE_CATEGORY,
} from '@/store/actions/media';
import * as _ from 'lodash';

export default {
  name: 'CategoryDialog',
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: null,
    },

  },
  emits: ['close-modal'],

  data () {
    return {
      category: {
        id: null,
        title: '',
      },
      isLoading: false,
    };
  },
  computed: {
    open: {
      // getter
      get: function() {
        return this.isOpen;
      },
      // setter
      set: function() {
        this.closeModal();
      },
    },
  },
  watch: {
    item: function(newVal) {
      if (newVal) {
        const { id, title } = newVal;
        this.category = {
          id, title,
        };
      }
    },
  },
  methods: {
    isEmpty (e) {
      return !_.isEmpty(e);
    },
    notifyAlert (message = '', type = 'success') {
      this.$notify({
        type,
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message,
      });
    },
    async createCategory () {
      this.isLoading = true;
      const { title } = this.category;
      try {
        await this.$store.dispatch(MEDIA_CREATE_CATEGORY, { title });
        this.notifyAlert('Se ha creado la categoria correctamente');
        this.closeModal();

      } catch (e) {
        this.isLoading = false;
        this.notifyAlert(
          'Tenemos problemas para crear la categoria',
          'danger',
        );
      }
    },
    async updateCategory () {
      this.isLoading = true;
      const category = this.category;

      try {
        await this.$store
          .dispatch(MEDIA_CATEGORY_UPDATE_NAME, category);
        this.notifyAlert('Se ha actualizado la categoria correctamente');
        this.closeModal();

      } catch (e) {
        this.isLoading = false;
        this.notifyAlert(
          'Tenemos problemas para actualizar la categoria',
          'danger',
        );
      }

    },
    closeModal () {
      this.$emit('close-modal', 'category');
      this.isLoading = false;
      this.val = null;
    },
  },
};
</script>
